/// <reference path="../../../../../typings/jquery.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/SchadenmeldungSchadenmeldungResponseApi.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { VesDamageValidationService } from '../../../../../../shared/services/VesDamageValidationService';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppApiService } from '../../services/AppApiService';
import { AppViewService } from '../../services/AppViewService';
import { UploadPersistenceService } from '../../../../../../shared/services/UploadPersistenceService';
import { ZusammenfassungStrukturApi } from '../../../../../../shared/models/generated/SchadenmeldungZusammenfassungStrukturApi';
import { VesErrorService } from '../../../../../../shared/services/VesErrorService';
import { AppApplicationModel } from '../../models/AppApplicationModel';

export class CheckOhcPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly applicationRouter: BasicApplicationRouter<DamageDeclarationOhcAppDefinition>;
	private readonly user: User;
	private readonly options: DamageDeclarationOhcOptions;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApiService: AppApiService;
	private readonly parent: AppController;
	private readonly loader: BasicLoader<DamageDeclarationOhcAppDefinition>;
	private appValidationService: VesDamageValidationService;
	private readonly uploadPersistenceService: UploadPersistenceService;
	private readonly vesErrorService: VesErrorService<DamageDeclarationOhcAppDefinition>;

	constructor(parent: AppController, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.user = user;
		this.$ctx = $(options.$ctx);

		this.applicationRouter = new BasicApplicationRouter(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appApiService = new AppApiService(options, user);
		this.appViewService = new AppViewService(parent, options, loader);
		this.uploadPersistenceService = new UploadPersistenceService(options);
		this.vesErrorService = new VesErrorService(options);
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			T.Utils.Helper.routeToUrl(this.options.app.entryredirecturl);
		}
	}

	private checkPreconditions(): boolean {
		const personalDataModel = this.appPersistenceService.getPersonalDataOhcFormModel();
		return ($('body').hasClass(this.options.app.pageEditorClass) || personalDataModel !== undefined);
	}

	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getApplicationModel();
		const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
		return {
			User: this.user,
			FormModel: formModel,
			UploadModel: uploadModel,
			nexturl: this.options.app.nexturl || '',
			prevurl: this.options.app.prevurl || '',
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.appValidationService = new VesDamageValidationService({ options: this.options }, this.appViewService.getForm(), false);
			this.parent.afterRenderApp();
			this.appViewService.addCheckDataListener(this.viewChangeListener.bind(this), this.submitListener.bind(this), this.backToStepListener.bind(this));

			AppUtils.View.stopLoader("damagedeclarationohc initApplication");
			AppUtils.View.scrollTop();
		});
	}

	public viewChangeListener(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appViewService.getFormModelFromCheckDataView();
			this.appPersistenceService.setCheckFormModelToStore(formModel);
		}, 'user-visible');
	}

	public submitListener(event: JQuery.Event): void {
		event.preventDefault();
		if (this.appValidationService.isValid()) {
			AppUtils.View.startLoader();
			const formModel = this.appPersistenceService.getApplicationModel();
			const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
			const summaryModel: ZusammenfassungStrukturApi = this.appViewService.getZusammenfassungStrukturApi();
			this.appApiService.submit(formModel, uploadModel, summaryModel, this.user, this.handleSubmitSuccessCallback.bind(this, formModel), this.handleSubmitErrorCallback.bind(this, formModel));
		}
	}

	private handleSubmitSuccessCallback(formModel: AppApplicationModel, data: ApiResponse<SchadenmeldungResponseApi>): void {
		formModel.CheckFormModel.TimeStamp = data.Data.Zeitstempel;
		this.appPersistenceService.setCheckFormModelToStore(formModel.CheckFormModel);
		this.sendMailConfirmation(formModel);
	}

	private handleSubmitErrorCallback(formModel: AppApplicationModel, jqxhr: JQueryXHR): void {
		if (this.vesErrorService.isShowSuccessPageError(jqxhr)) {
			const data = jqxhr.responseJSON as ApiResponse<SchadenmeldungResponseApi>;
			formModel.CheckFormModel.TimeStamp = data.Data.Zeitstempel;
			this.appPersistenceService.setCheckFormModelToStore(formModel.CheckFormModel);
			this.sendMailConfirmation(formModel);
		} else {
			AppUtils.Helper.logError(jqxhr, 'SchadenApplikation', window.location.href);
			T.Utils.Helper.routeToUrl(this.options.app.errorpageurl);
		}
	}

	private sendMailConfirmation(formModel: AppApplicationModel): void {
		this.appApiService.submitMailConfirmation(formModel.PersonalDataFormModel.PersoenlicheDaten.Email,
			formModel.CheckFormModel.TimeStamp,
			() => {
				this.applicationRouter.next();
			},
			() => {
				this.applicationRouter.next();
			});
	}

	public backToStepListener(event: JQuery.TriggeredEvent): void {
		event.preventDefault();
		AppUtils.View.startLoader("CheckOhcPageController backToStepListener");
		if ($(event.currentTarget).hasClass('js-back-step-1')) {
			this.applicationRouter.routeToLocation(this.options.app.pagestep0);
		} else if ($(event.currentTarget).hasClass('js-back-step-2')) {
			this.applicationRouter.routeToLocation(this.options.app.pagestep1);
		} else if ($(event.currentTarget).hasClass('js-back-step-3')) {
			this.applicationRouter.routeToLocation(this.options.app.pagestep2);
		}
		AppUtils.View.stopLoader("CheckOhcPageController backToStepListener");
	}
}
